<template>
  <v-card-actions class="helmi-form-actions">
    <slot/>
  </v-card-actions>
</template>

<script>
export default {
  name: 'HelmiFormActions',
};
</script>

<style lang="scss">
.helmi-form-actions {
  max-width: 1024px;
}
</style>
